<template>
	<div class="box box_mm">
		<div class="box_main">
			<div class="search_box">
				<div class="search_item">
					<span style="width: 0.6rem;">名称：</span>
					<el-input v-model="searchinput" placeholder="请输入名称" style="width: 2rem;"></el-input>
				</div>
				<div class="search_item">
					<el-button type="primary" @click="search">搜索</el-button>
				</div>
			</div>
			<div class="box_cont">
				<div class="btn_list">
				</div>
				<div style="height: 76vh;box-sizing: border-box;">
					<MyTable ref="zjlist" :tableData="tableData" :tableHeader="tableHeader" :showbm="true"
						:czwidth="110" @getdata="gettable" @changswitch="changswitch">
						<template slot="btns" slot-scope="{ scope }">
							<el-button @click="lookdetail(scope.row)" type="success" size="mini">
								详情
							</el-button>	
						</template>
					</MyTable>
				</div>
			</div>
		</div>			
		
		
	</div>
</template>

<script>	
	export default{		
		data() {
			return{
				searchinput:'',
				tableHeader: [{
						prop: 'id',
						name: '序',
						width: '50'
					},					
					{
						prop: 'name',
						name: '标题',
						width: ''
					},
					{
						prop: 'stage.name',
						name: '所属驿站',
						width: ''
					},
					{
						prop: 'apply_status',
						name: '状态',
						width: '120',
						type:'status_lztb'
					},
					{
						prop: 'updatetime',
						name: '创建时间',
						width: ''
					}
				],
				tableData: [],
			}
		},
		mounted() {
			this.gettable()
		},
		methods:{
			addnewyz(){
				this.$router.push('/system/yun_yizhan_newsadd')
			},	
			lookdetail(row){
				this.$router.push({path:"/system/yun_yizhan_newsdetail",query:{id:row.id}})
			},
			showeidt(row){
				this.$router.push({path:"/system/yun_yizhan_newsedit",query:{id:row.id}})
			},
			changswitch(row){
				this.$post({
					url: '/api/room/edit',
					params: row
				}).then((res) => {
					this.$message({
						type: 'success',
						message: '操作成功!'
					})
					this.gettable()
				})
			},
			search(){
				this.$refs.zjlist.inputpage = 1
				this.gettable()
			},
			deleterow(row){
				this.$confirm('确认删除该条数据吗？')
					.then(_ => {
						this.$post({
							url: '/api/stage_news/del',
							params: {
								ids: row.id
							}
						}).then((res) => {
							this.$message.success('删除成功')
							this.gettable()
						})
					})
					.catch(_ => {});
			},
			gettable(){
				this.$post({
					url: '/api/stage_news/index',
					params: {
						apply_status:1,
						name: this.searchinput,
						p: this.$refs.zjlist.inputpage,
						size: this.$refs.zjlist.pagesize
					}
				}).then((res) => {
					this.tableData = res.list
					this.$refs.zjlist.total = res.count
				})
			},
			addnew(){
				this.$router.push('/system/meeting_add')
			},
			showdate(row){
				this.$refs.myroomdate.dialogVisible = true
			},
		}
	}
</script>

<style lang="scss" scoped>
	@import 'news.scss';
</style>